import { AssignmentEntityType } from 'domain/shared/assignment';
import { AssignmentFormItem, PoliciesDataType, RelatedEmployeeFilter } from 'domain/shared/compliance';
import { ListData } from 'framework/list';

export enum ComplianceCoverageStatus {
  NOT_SIGNED = 'NOT_SIGNED',
  SIGNED = 'SIGNED',
  LOADING = 'LOADING',
  UNAVAILABLE = 'UNAVAILABLE',
}

export type ComplianceCoverageStatusFallback = Exclude<ComplianceCoverageStatus, 'SIGNED'>;
export type ComplianceCoverageStatusView = {
  color: 'success' | 'error' | 'warning' | 'default';
  label: string;
};
export type ComplianceDocumentStatusView = {
  color: 'success' | 'default';
  infoMessage?: string;
  label: 'Published' | 'Unpublished' | 'Outdated';
  shouldLoadStatuses: boolean;
};
export type ComplianceDocumentMatchParams = {
  complianceName?: string;
  currentDocumentPath?: string;
  currentDocumentVersion?: number | string;
};
export type ComplianceDocumentStatusViewOptions = {
  isOutdated?: boolean;
};

export type ComplianceCoverageEmployee = {
  employeeAlias: string;
  employeeFullName: string;
  employeePositionId: number;
  complianceDocument?: Nullable<PoliciesDataType>;
  status: ComplianceCoverageStatus;
};

export type ComplianceAudienceEmployee = {
  employeeAlias: string;
  employeeFullName: string;
  employeePositionId: number;
};

export type UseComplianceAudienceCoverageServiceParams = {
  complianceName?: string;
  currentDocumentPath?: string;
  version?: number;
  shouldLoadStatuses: boolean;
  useLegacyAudienceWorkers?: boolean;
  relatedEmployeeFilter?: Nullable<RelatedEmployeeFilter>;
  relatedEmployeeContractTypes?: string[] | null;
  assignments?: AssignmentFormItem[];
};

type ComplianceWorker = {
  name: string;
  alias: string;
  isSigned: boolean;
};

export type ComplianceWorkersResponse = {
  pageNumber?: number;
  result?: ComplianceWorker[];
  totalElements?: number;
  totalPages?: number;
};

export type AudienceEmployeeSearchResultItem = {
  alias: string;
  nameEn?: { firstName?: string; lastName?: string; maidenName?: string };
  positionId?: number;
  contractType?: string;
};

export type AudienceEmployeeSearchResponse = Partial<
  Pick<ListData<AudienceEmployeeSearchResultItem>, 'result' | 'totalPages'>
>;

export type AssignmentSearchResponse = Partial<Pick<ListData<AssignmentEntityType>, 'result' | 'totalPages'>>;

export type AssignmentIdsByAudience = {
  relatedProjectIds: string[];
  relatedAccountIds: string[];
};

export type ModalLoadingState = {
  nextPageNumber: number;
  totalPages: number;
};
